import { defineStore } from 'pinia';
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";
import { sDs } from '@common/sDs/sDs';

let navigationStoreOptions = {
    state: () => ({
        views: {},
        history: [],
        showInComponents: [
            'workflowViewer',
            'profile'
        ],
        allowedButtons: ['popup', 'window'],
        availableNavigations: {},
        projectWithRouter: false
    }),
    getters: {
        getViews(state) {
            return () => state.views;
        },
    },
    actions: {
        async init() {
            if (typeof PROJECT_WITH_ROUTER !== 'undefined' && window.name.indexOf('System_') !== -1) {
                this.projectWithRouter = true;
                this.availableNavigations = await configStore.getEcNavigation();
                window.open = (function (open) {
                    return function (url, windowName, features) {
                        let openedWindow = open.call(window, url, windowName, features);
                        openedWindow.addEventListener('unload', () => {
                            setTimeout(() => {
                                if (openedWindow.closed) {
                                    window?.navigationStore?.()?.closeView(windowName);
                                }
                            }, 1000);
                        });
                        window.navigationStore().createView({
                            windowName: windowName,
                            url: url,
                            features: features
                        }, 'window', true);
                        return openedWindow;
                    };
                }(window.open));

                let oldOnload = window.onload;
                window.onload = function () {
                    uStore().getLoggedUsers(['user']).then((loggedUser) => {
                        if (parseInt(loggedUser, 10)) {
                            window.navigationStore().restoreUrl();
                        }
                    });
                    if (typeof oldOnload === 'function') oldOnload();
                };
            }
        },
        addToHistory(view) {
            if (!this.projectWithRouter) return;
            let isExists = this.history.find((tmp) => library.isEqualObj(tmp, view));
            if (!isExists) this.history.push(view);
        },
        createView(config, openedIn, addToHistory) {
            if (!this.projectWithRouter) return false;
            let viewId;
            for (let tmpViewId in this.views) {
                if (library.isEqualObj(this.views[tmpViewId].config, config)) {
                    viewId = tmpViewId;
                }
            }
            if (!viewId && config.windowName) viewId = config.windowName;
            if (!viewId) viewId = config.cId + '_' + config.cType + '_' + library.getUniqueID();
            if (this.views[viewId]) {
                this.editView(viewId, config);
                if (openedIn) {
                    this.editView(viewId, {
                        openedIn: openedIn
                    });
                }
            } else {
                this.views[viewId] = {
                    viewId: viewId,
                    config: config
                };
                this.views[viewId].openedIn = openedIn || false;
                if (addToHistory) this.addToHistory(config);
            }
            this.calculateUrl();
            return viewId;
        },
        editView(viewId, config) {
            if (!this.projectWithRouter) return;
            if (this.views[viewId]) {
                for (let prop in config) {
                    if (prop === 'openedIn' || prop === 'dialogObj') {
                        this.views[viewId][prop] = config[prop];
                    } else {
                        this.views[viewId].config[prop] = config[prop];
                    }
                }
                this.calculateUrl();
            }
        },
        closeView(viewId) {
            if (!this.projectWithRouter) return;
            let view = this.views[viewId];
            if (view) {
                if (view.openedIn === 'min') return;
                if (view.openedIn === 'popup') {
                    view?.dialogObj?.hide?.();
                }
                if (view.openedIn === 'window') {
                    view?.winObj?.close?.();
                }
                // if popup/window - close
                view.openedIn = false;
                this.calculateUrl();
            }
        },
        async openIn(viewId, type) {
            if (!this.projectWithRouter) return;
            let view = this.views[viewId];
            if (view && view?.config) {
                if (view.openedIn === 'popup') {
                    view?.dialogObj?.hide?.();
                    await library.sleep(1000);
                }
                if (view.openedIn === 'window' && type !== 'window') {
                    view?.winObj?.close?.();
                }
                switch (type) {
                    case 'window':
                        view.openedIn = 'window';
                        if (view.config.cId) {
                            let cConfig = JSON.stringify([this.views[viewId].config]);
                            try {
                                this.views[viewId].winObj = window.open(PROJECTS_URL + 'coordinator/?navigationStore=1&componentView=1&components=' + cConfig + '', viewId);
                            } catch (e) {
                                // do nothing
                            }
                        } else {
                            try {
                                this.views[viewId].winObj = window.open(this.views[viewId].config.url, this.views[viewId].config.windowName, this.views[viewId].config.features);
                            } catch (e) {
                                // do nothing
                            }
                        }
                        break;
                    case 'popup':
                        view.openedIn = 'popup';
                        if (view.config.cId) {
                            actionStore.openComponentDialog({
                                componentId: view.config.cId,
                                componentProps: view.config,
                                dialogSettings: {
                                    preventCloseOnBackdropClick: true,
                                    showCloseIcon: true,
                                    closeOnEscape: false,
                                    isComponentDialog: true,
                                    cssClass: 'show-only-content-popup',
                                    funcOpen: (_this) => {
                                        view.dialogObj = _this;
                                    },
                                    funcPostClose: () => {
                                        if (this.views[viewId].openedIn === 'popup') this.closeView(viewId);
                                    }
                                }
                            });
                        } else {
                            actionStore.actions.iframeProcessSubmit('customUrl', {
                                url: view.config.url,
                                windowName: view.config.windowName,
                                openInSameWindow: true
                            }, view.config.width, view.config.height);
                        }
                        break;
                    case 'min':
                        view.openedIn = 'min';
                        break;
                    case 'max':
                        view.openedIn = 'max';
                        break;
                }
                this.addToHistory(this.views[viewId].config);
            }
            this.calculateUrl();
        },
        restoreUrl() {
            if (!this.projectWithRouter) return;
            let tmpViews = typeof router?.currentRoute?.value?.query?.views === 'string' && JSON.parse(router.currentRoute.value.query.views);
            if (library.objIsEmpty(tmpViews)) tmpViews = [];
            // this.views = tmpViews;
            for (let i in tmpViews) {
                this.views[i] = tmpViews[i];
                if (tmpViews[i].openedIn === 'window' || tmpViews[i].openedIn === 'popup') {
                    this.openIn(tmpViews[i].viewId, tmpViews[i].openedIn);
                }
            }
        },
        calculateUrl() {
            if (!this.projectWithRouter) return;
            let tmpQuery = {};
            let tmpViews = {};
            for (let i in this.views) {
                if (this.views[i].openedIn) {
                    tmpViews[i] = library.cloneObj(this.views[i]);
                    delete tmpViews[i].dialogObj;
                    delete tmpViews[i].winObj;
                }
            }
            if (!library.objIsEmpty(tmpViews)) tmpQuery['views'] = JSON.stringify(tmpViews);
            router.push({
                path: router.currentRoute.value.path,
                query: tmpQuery
            });
        }
    }
};

const navigationStore = defineStore('navigationStore', navigationStoreOptions);

let getTopNavigationStore = (winObj) => {
    // all manipulation should go in main window
    try {
        if (window.top !== window) {
            // iframe
            winObj = window.top;
        } else {
            while (winObj !== window.opener) winObj = window.opener;
        }
        let tmpNavigationStore = winObj?.navigationStore;
        if (!tmpNavigationStore && window.name.indexOf('System_') !== -1) tmpNavigationStore = navigationStore;
        if (!tmpNavigationStore) tmpNavigationStore = false;
        return tmpNavigationStore;
    } catch (e) {
        return false;
    }
};

window.navigationStore = getTopNavigationStore(window);

export { navigationStore };
